// This file is generated by a script and should not be modified directly.
const markdown: string = "A job opportunity has a life cycle: a creation date and an expiration date.\n"
export default markdown
